import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class Endpoints {

  /**
   * Internal Documentation
   */
  get_internal_documentation_leftmenu: string = 'documentation/internal/leftmenu/';
  get_internal_documentation_list: string = 'documentation/internal/list/';
  get_internal_documentation_by_docId: string = 'documentation/internal/';
  delete_document: string = 'documentation/internal/';
  create_update_document: string = 'documentation/internal';


  /**
   * Public Documentation
   */
  get_public_documentation_list: string = 'documentation/list/';
  delete_public_document: string = 'documentation/';
  create_update_public_document: string = 'documentation';
  get_documentation_list: string = 'documentation/';

  /**
   * Entity Management
   */
  /* Counties */
  get_counties_list: string = 'EntityManagement/getcountylist';
  manage_county_details_list: string = 'EntityManagement/managecountydetails';
  activate_deactivate_county: string = 'EntityManagement/account/';
  get_county_uploaded_documents: string = 'EntityManagement/';
  get_couty_homestead_checklist: string = 'EntityManagement/';

  /* Counties Users */
  get_counties_users_list: string = 'EntityManagement/getcountyuserlist/';
  manage_county_users_list: string = 'EntityManagement/managecountyuserdetails';
  activate_deactivate_user: string = 'EntityManagement/user/';

  /* Users */
  get_users_list: string = 'EntityManagement/getuserlist';
  get_invoice_details_create: string = 'EntityManagement/getinvoicedetailsforcreate';
  get_invoice_create: string = 'EntityManagement/invoicecreate';

  /* Vehicles */
  get_vehicle_list: string = 'EntityManagement/getvehiclelist';
  get_vehicle_information_details: string = 'EntityManagement/getvehicleinformationdetails/';
  get_vehicle_historical_data: string = 'EntityManagement/getvehiclehistoricaldata';
  /* Login */
  get_Login: string = 'Utility/login';

  /* Pricing Plan */
  get_pricingPlan_list: string = 'EntityManagement/getpricingplanlist';
  manage_Plan_details: string = 'EntityManagement/manageplandetails';
  get_dateRangesForPlan: string = 'EntityManagement/getdaterangesforplan/';
  manage_dateRangeForPlan: string = 'EntityManagement/managedaterangeforplan';
  get_descriptivesForPlan: string = 'EntityManagement/getdescriptivesforplan/';
  manage_descriptiveForPlan: string = 'EntityManagement/managedescriptiveforplan';

  /* Invoices */
  get_invoices_list: string = 'EntityManagement/getaccountinvoicelist';
  get_invoices_details_list: string = 'EntityManagement/getaccountinvoicedetails/';
  get_invoices_valuation_details_list: string = 'EntityManagement/getaccountvehiclevaluationdetailsforcreateinvoice';
  mark_invoice_as_paid: string = 'EntityManagement/markinvoiceaspaid';
  delete_invoice: string = 'EntityManagement/invoice/';

  /* County Portal*/
  get_county_basic_info: string = 'managecountyportal/county/';
  get_county_portal_users_list: string = 'managecountyportal/users/list';
  activate_deactivate_county_portal_users: string = 'managecountyportal/users/';
  manage_county_portal_users: string = 'managecountyportal/users/manage';
  get_county_portal_entities_list: string = 'managecountyportal/entities/list';
  activate_deactivate_county_portal_entities: string = 'managecountyportal/entities/';
  manage_county_portal_entities: string = 'managecountyportal/entities/manage';
  manage_county_portal_entity_permission: string = 'managecountyportal/entitypermission/list';
  manage_county_portal_entities_permission: string = 'managecountyportal/entitypermission/manage';
  manage_county_portal_notificationsetup: string = 'managecountyportal/notificationsetup/list';
  manage_county_portal_notificationsetup_manage: string = 'managecountyportal/notificationsetup/manage';
  manage_county_portal_entities_dropdown: string = 'managecountyportal/dropdowns/entities';
  manage_roles_dropdown: string = 'managecountyportal/dropdowns/countyroles';
  manage_county_portal_dropdown: string = 'managecountyportal/dropdowns/';
  manage_county_portal_application_status_list: string = 'managecountyportal/dropdowns/';
  manage_county_portal_notification_setup_commonSetupsById: string = 'managecountyportal/notificationsetup/';
  manage_county_portal_entities_url: string = 'managecountyportal/entities/';
  manage_county_portal_entities_url_list: string = 'managecountyportal/entityurls/list';
  manage_county_portal_entities_url_manage: string = 'managecountyportal/entityurls/manage/';
  manage_county_portal_dropdwon_counties: string = 'managecountyportal/dropdowns/counties';
  umanage_county_portal_enums_dropdown: string = 'managecountyportal/dropdowns/enums';
  manage_county_portal_dropdwon_application_tax_year: string = 'managecountyportal/dropdowns/applicationtaxyears';
  umanage_county_portal_learnmore_detail: string = 'managecountyportal/learnmore/';
  /**
    * Settings -> Valid Parcels
    * **/
  valid_parcel_grid_list: string = 'managecountyportal/parcel/list';
  valid_parcel_history_list: string = 'managecountyportal/parcel/historylist';
  valid_parcel_upload: string = 'managecountyportal/parcel/upload';
  valid_parcel_download: string = 'managecountyportal/parcel/download';
  valid_parcel_manage_adhoc_parcel: string = 'managecountyportal/parcel/create';


  manage_portal_access_add: string = 'EntityManagement/manageportalaccess';
  /**
   * Download: Import Template
   * **/
  import_template_download: string = 'managecountyportal/download/importtemplate/';

  /* General*/
  general_scheduledjob_log_list: string = 'general/logs/scheduledjob';
  general_homesteadcredit_log_list: string = 'general/logs/homesteadcredit';
  general_countyadmin_log_list: string = 'general/logs/countyadmin';
  general_clearbasin_log_list: string = 'general/logs/clearbasin';
  general_configuration_log_list: string = 'general/logs/configurations';
  general_release_list: string = 'general/release/list';
  general_release_functionality_list: string = 'general/release/';
  manage_general_release: string = 'general/release/manage';


  /**
   * UTILITY
   */
  utility_dropdown: string = 'Utility/dropdowns';
  utility_dropdown_settings: string = 'Utility/dropdown';
  utility_pricing_plans: string = 'Utility/dropdowns/pricingplans';
  utility_accounts: string = 'Utility/dropdowns/accounts';
  utility_profile_details_by_id: string = 'Utility/profile/';
  utility_dropdown_makes: string = 'Utility/dropdowns/makes';
  utility_models_by_make_id: string = 'Utility/dropdowns/models/';
  utility_vehicle_types_mappings: string = 'Utility/getvehicletypemappings';
  utility_delete_vehicle_types_mapping: string = 'Utility/vehicletypemapping/';
  utility_manage_vehicle_types_mappings: string = 'Utility/managevehicletypemapping';
  utility_capps_vehicle_types_mappings: string = 'Utility/getcappsvehicletypes';
  utility_delete_capps_vehicle_types_mapping: string = 'Utility/cappsvehicletype/';
  utility_manage_capps_vehicle_types_mappings: string = 'Utility/managecappsvehicletype';
  utility_stl_vehicle_types_mappings: string = 'Utility/getstlvehicletypes';
  utility_delete_stl_vehicle_types_mapping: string = 'Utility/stlvehicletype/';
  utility_manage_stl_vehicle_types_mappings: string = 'Utility/managestlvehicletype';
  utility_get_account_period_list: string = 'Utility/getaccountperiodlist';
  utility_update_account_period: string = 'Utility/updateaccountperiod';
  utility_add_account_period: string = 'Utility/addaccountperiods';
  utility_synced_vpic_makes: string = 'Utility/syncedvpicmakes';
  utility_sync_makes_by_vpic_VehicleTypeId: string = 'Utility/syncvpicmakes/';
  utility_synced_vpic_models: string = 'Utility/syncedvpicmodels';
  utility_sync_vpic_models: string = 'Utility/syncvpicmodels';
  utility_vpic_vehicle_type_dropdown: string = 'Utility/dropdown/vpicvehicletype';
  utility_vpic_make_dropdown: string = 'Utility/dropdown/makesbyvpicvehicletype/';
  utility_get_process_stl_data: string = 'Utility/getvaluesourceprocessingfilesdata';
  utility_download_process_stl_file: string = 'Utility/downloadvaluesourcedataprocessingfile';
  utility_upload_process_stl_file: string = 'Utility/processvaluesourcedata';
  utility_dropdowns_admin_roles: string = 'Utility/dropdowns/adminroles';


  /* Users List */
  get_user_list: string = 'users/list';
  get_user_manage: string = 'users/manage';
  /**
   * Valuation
   */
  clear_cache: string = 'Cache';


  /*
  * Roles and Perimissions
  */
  get_save_roles_permission_mapping: string = 'managecountyportal/rolespermission/'; // {CountyId} as route path need to add

  get httpHeader(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  // Append APIBase url with endpoint
  appendApiBaseUrl(url: string): string {
    return environment.apiConfig.apiBaseUrl + url;
  }

  appendValuationApiBaseUrl(url: string): string {
    return environment.apiConfig.valuationApiBaseUrl + url;
  }
}
